module.exports = __webpack_public_path__ + "static/book-e79960c24e5151ac6b983576f0543635.png";